import { BaseParameterTypes, DefaultMnemonic, WellStatuses } from './api/types';

export const statusesSortStructure = [
  WellStatuses.ACTIVE_GREEN,
  WellStatuses.ACTIVE_YELLOW,
  WellStatuses.ACTIVE_RED,
  WellStatuses.COMPLETED,
  WellStatuses.BAD,
];

export const timeSortedParameters = [
  BaseParameterTypes.AUTO_RECOGNIZED_OPERATIONS,
  BaseParameterTypes.AUTO_RECOGNIZED_EVENTS,
  BaseParameterTypes.DEPTH_HOLE,
  BaseParameterTypes.DEPTH_BIT,
  BaseParameterTypes.BLOCK_POSITION,
  BaseParameterTypes.HOOKLOAD,
  BaseParameterTypes.WEIGHT_ON_BIT,
  BaseParameterTypes.BIT_CONTACT_PRESSURE,
  BaseParameterTypes.ROTARY_SPEED,
  BaseParameterTypes.BIT_SPEED,
  BaseParameterTypes.ROTARY_TORQUE,
  BaseParameterTypes.MUD_FLOW_IN,
  BaseParameterTypes.MUD_FLOW_OUT,
  BaseParameterTypes.MUD_FLOW_OUT_PERCENT,
  BaseParameterTypes.TOTAL_PUMPS_STROKE_RATE,
  BaseParameterTypes.STANDPIPE_PRESSURE,
  BaseParameterTypes.SURFACE_ANNULAR_PRESSURE,
  BaseParameterTypes.MUD_DENSITY_IN,
  BaseParameterTypes.MUD_DENSITY_OUT,
  BaseParameterTypes.ECD_AT_BIT,
  BaseParameterTypes.ECD_AT_TOTAL_DEPTH,
  BaseParameterTypes.RATE_OF_PENETRATION,
  BaseParameterTypes.MECH_SPEC_ENERGY_SURFACE,
  BaseParameterTypes.MECH_SPEC_ENERGY_BIT,
  BaseParameterTypes.RUNNING_SPEED,
  BaseParameterTypes.ACTIVE_TANK_VOLUME,
  BaseParameterTypes.TRIP_TANK_VOLUME,
  BaseParameterTypes.TOTAL_GAS,
  BaseParameterTypes.SURVEY_INC,
  BaseParameterTypes.SURVEY_AZI,
  BaseParameterTypes.SURVEY_AZI_CORR,
  BaseParameterTypes.SURVEY_DOGLEG,
  BaseParameterTypes.MAGNETIC_TOOLFACE,
  BaseParameterTypes.GRAVITY_TOOLFACE,
  BaseParameterTypes.NUMBER_OF_JOINTS,
];

export const depthSortedParameters = [
  BaseParameterTypes.HOOKLOAD,
  BaseParameterTypes.WEIGHT_ON_BIT,
  BaseParameterTypes.BIT_CONTACT_PRESSURE,
  BaseParameterTypes.ROTARY_SPEED,
  BaseParameterTypes.BIT_SPEED,
  BaseParameterTypes.ROTARY_TORQUE,
  BaseParameterTypes.MUD_FLOW_IN,
  BaseParameterTypes.MUD_FLOW_OUT,
  BaseParameterTypes.MUD_FLOW_OUT_PERCENT,
  BaseParameterTypes.STANDPIPE_PRESSURE,
  BaseParameterTypes.MUD_DENSITY_IN,
  BaseParameterTypes.MUD_DENSITY_OUT,
  BaseParameterTypes.ECD_AT_BIT,
  BaseParameterTypes.RATE_OF_PENETRATION,
  BaseParameterTypes.MECH_SPEC_ENERGY_SURFACE,
  BaseParameterTypes.MECH_SPEC_ENERGY_BIT,
  BaseParameterTypes.TOTAL_GAS,
  BaseParameterTypes.SURVEY_INC,
  BaseParameterTypes.SURVEY_AZI,
  BaseParameterTypes.SURVEY_AZI_CORR,
  BaseParameterTypes.SURVEY_DOGLEG,
  BaseParameterTypes.MAGNETIC_TOOLFACE,
  BaseParameterTypes.GRAVITY_TOOLFACE,
  BaseParameterTypes.RESISTIVITY_1,
  BaseParameterTypes.RESISTIVITY_2,
  BaseParameterTypes.GAMMA_RAY_1,
  BaseParameterTypes.GAMMA_RAY_2,
  BaseParameterTypes.POROSITY_1,
  BaseParameterTypes.POROSITY_2,
  BaseParameterTypes.THERMAL_NEUTRON_POROSITY,
];

export const PARAMS_GRID_TITLES = ['parameter', 'company', 'log', 'mnemonic'];

export const nameDictionary: Record<BaseParameterTypes, string> = {
  [BaseParameterTypes.DEPTH_HOLE]: 'holeDepth',
  [BaseParameterTypes.AUTO_RECOGNIZED_OPERATIONS]: 'operation',
  [BaseParameterTypes.DEPTH_BIT]: 'bitDepth',
  [BaseParameterTypes.AUTO_RECOGNIZED_EVENTS]: 'event',
  [BaseParameterTypes.HOOKLOAD]: 'hookload',
  [BaseParameterTypes.STANDPIPE_PRESSURE]: 'standpipePressure',
  [BaseParameterTypes.ROTARY_TORQUE]: 'rotaryTorque',
  [BaseParameterTypes.BLOCK_POSITION]: 'blockPosition',
  [BaseParameterTypes.MUD_FLOW_IN]: 'mudFlowIn',
  [BaseParameterTypes.ROTARY_SPEED]: 'rotarySpeed',
  [BaseParameterTypes.WEIGHT_ON_BIT]: 'weightOnBit',
  [BaseParameterTypes.RATE_OF_PENETRATION]: 'penetrationRate',
  [BaseParameterTypes.GRAVITY_TOOLFACE]: 'gravityToolface',
  [BaseParameterTypes.MAGNETIC_TOOLFACE]: 'magneticToolface',
  [BaseParameterTypes.BIT_CONTACT_PRESSURE]: 'bitContactPressure',
  [BaseParameterTypes.MECH_SPEC_ENERGY_SURFACE]: 'mechSpecEnergySurface',
  [BaseParameterTypes.MECH_SPEC_ENERGY_BIT]: 'mechSpecEnergyBit',
  [BaseParameterTypes.BIT_SPEED]: 'bitSpeed',
  [BaseParameterTypes.MUD_FLOW_OUT]: 'mudFlowOut',
  [BaseParameterTypes.MUD_FLOW_OUT_PERCENT]: 'mudFlowOutPercent',
  [BaseParameterTypes.TOTAL_PUMPS_STROKE_RATE]: 'totalPumpsStrokeRate',
  [BaseParameterTypes.SURFACE_ANNULAR_PRESSURE]: 'surfaceAnnularPressure',
  [BaseParameterTypes.MUD_DENSITY_IN]: 'mudDensityIn',
  [BaseParameterTypes.MUD_DENSITY_OUT]: 'mudDensityOut',
  [BaseParameterTypes.ECD_AT_BIT]: 'ecdAtBit',
  [BaseParameterTypes.ECD_AT_TOTAL_DEPTH]: 'ecdAtTotalDepth',
  [BaseParameterTypes.RUNNING_SPEED]: 'runningSpeed',
  [BaseParameterTypes.ACTIVE_TANK_VOLUME]: 'activeTankVolume',
  [BaseParameterTypes.TRIP_TANK_VOLUME]: 'tripTankVolume',
  [BaseParameterTypes.TOTAL_GAS]: 'totalGas',
  [BaseParameterTypes.SURVEY_INC]: 'surveyInc',
  [BaseParameterTypes.SURVEY_AZI]: 'surveyAzi',
  [BaseParameterTypes.SURVEY_AZI_CORR]: 'surveyAziCorr',
  [BaseParameterTypes.SURVEY_DOGLEG]: 'surveyDogleg',
  [BaseParameterTypes.RESISTIVITY_1]: 'resistivity1',
  [BaseParameterTypes.RESISTIVITY_2]: 'resistivity2',
  [BaseParameterTypes.GAMMA_RAY_1]: 'gammaRay1',
  [BaseParameterTypes.GAMMA_RAY_2]: 'gammaRay2',
  [BaseParameterTypes.POROSITY_1]: 'porosity1',
  [BaseParameterTypes.POROSITY_2]: 'porosity2',
  [BaseParameterTypes.THERMAL_NEUTRON_POROSITY]: 'thermalNeutronPorosity',
  [BaseParameterTypes.NUMBER_OF_JOINTS]: 'numberOfJoints',
};

export const defaultMnemonicsDictionary: Record<BaseParameterTypes, readonly DefaultMnemonic[]> = {
  [BaseParameterTypes.DEPTH_HOLE]: [DefaultMnemonic.DEPTH_HOLE],
  [BaseParameterTypes.AUTO_RECOGNIZED_OPERATIONS]: [DefaultMnemonic.AUTO_RECOGNIZED_OPERATIONS],
  [BaseParameterTypes.DEPTH_BIT]: [DefaultMnemonic.DEPTH_BIT],
  [BaseParameterTypes.AUTO_RECOGNIZED_EVENTS]: [DefaultMnemonic.AUTO_RECOGNIZED_EVENTS],
  [BaseParameterTypes.HOOKLOAD]: [DefaultMnemonic.HOOKLOAD],
  [BaseParameterTypes.STANDPIPE_PRESSURE]: [DefaultMnemonic.STANDPIPE_PRESSURE],
  [BaseParameterTypes.ROTARY_TORQUE]: [DefaultMnemonic.ROTARY_TORQUE],
  [BaseParameterTypes.BLOCK_POSITION]: [DefaultMnemonic.BLOCK_POSITION],
  [BaseParameterTypes.MUD_FLOW_IN]: [DefaultMnemonic.MUD_FLOW_IN],
  [BaseParameterTypes.ROTARY_SPEED]: [DefaultMnemonic.ROTARY_SPEED],
  [BaseParameterTypes.WEIGHT_ON_BIT]: [DefaultMnemonic.WEIGHT_ON_BIT],
  [BaseParameterTypes.RATE_OF_PENETRATION]: [DefaultMnemonic.RATE_OF_PENETRATION],
  [BaseParameterTypes.GRAVITY_TOOLFACE]: [DefaultMnemonic.GRAVITY_TOOLFACE],
  [BaseParameterTypes.MAGNETIC_TOOLFACE]: [DefaultMnemonic.MAGNETIC_TOOLFACE],
  [BaseParameterTypes.BIT_CONTACT_PRESSURE]: [DefaultMnemonic.BIT_CONTACT_PRESSURE],
  [BaseParameterTypes.MECH_SPEC_ENERGY_SURFACE]: [DefaultMnemonic.MECH_SPEC_ENERGY_SURFACE],
  [BaseParameterTypes.MECH_SPEC_ENERGY_BIT]: [DefaultMnemonic.MECH_SPEC_ENERGY_BIT],
  [BaseParameterTypes.BIT_SPEED]: [DefaultMnemonic.BIT_SPEED],
  [BaseParameterTypes.MUD_FLOW_OUT]: [DefaultMnemonic.MUD_FLOW_OUT],
  [BaseParameterTypes.MUD_FLOW_OUT_PERCENT]: [DefaultMnemonic.MUD_FLOW_OUT_PERCENT],
  [BaseParameterTypes.TOTAL_PUMPS_STROKE_RATE]: [DefaultMnemonic.TOTAL_PUMPS_STROKE_RATE],
  [BaseParameterTypes.SURFACE_ANNULAR_PRESSURE]: [DefaultMnemonic.SURFACE_ANNULAR_PRESSURE],
  [BaseParameterTypes.MUD_DENSITY_IN]: [DefaultMnemonic.MUD_DENSITY_IN],
  [BaseParameterTypes.MUD_DENSITY_OUT]: [DefaultMnemonic.MUD_DENSITY_OUT],
  [BaseParameterTypes.ECD_AT_BIT]: [DefaultMnemonic.ECD_AT_BIT],
  [BaseParameterTypes.ECD_AT_TOTAL_DEPTH]: [DefaultMnemonic.ECD_AT_TOTAL_DEPTH],
  [BaseParameterTypes.RUNNING_SPEED]: [DefaultMnemonic.RUNNING_SPEED],
  [BaseParameterTypes.ACTIVE_TANK_VOLUME]: [DefaultMnemonic.ACTIVE_TANK_VOLUME],
  [BaseParameterTypes.TRIP_TANK_VOLUME]: [DefaultMnemonic.TRIP_TANK_VOLUME, DefaultMnemonic.TRIP_TANK_VOLUME_ALT],
  [BaseParameterTypes.TOTAL_GAS]: [DefaultMnemonic.TOTAL_GAS],
  [BaseParameterTypes.SURVEY_INC]: [DefaultMnemonic.SURVEY_INC],
  [BaseParameterTypes.SURVEY_AZI]: [DefaultMnemonic.SURVEY_AZI],
  [BaseParameterTypes.SURVEY_AZI_CORR]: [DefaultMnemonic.SURVEY_AZI_CORR],
  [BaseParameterTypes.SURVEY_DOGLEG]: [DefaultMnemonic.SURVEY_DOGLEG],
  [BaseParameterTypes.RESISTIVITY_1]: [DefaultMnemonic.RESISTIVITY_1, DefaultMnemonic.RESISTIVITY_1_ALT],
  [BaseParameterTypes.RESISTIVITY_2]: [DefaultMnemonic.RESISTIVITY_2, DefaultMnemonic.RESISTIVITY_2_ALT],
  [BaseParameterTypes.GAMMA_RAY_1]: [DefaultMnemonic.GAMMA_RAY_1, DefaultMnemonic.GAMMA_RAY_1_ALT],
  [BaseParameterTypes.GAMMA_RAY_2]: [DefaultMnemonic.GAMMA_RAY_2, DefaultMnemonic.GAMMA_RAY_2_ALT],
  [BaseParameterTypes.POROSITY_1]: [DefaultMnemonic.POROSITY_1],
  [BaseParameterTypes.POROSITY_2]: [DefaultMnemonic.POROSITY_2],
  [BaseParameterTypes.THERMAL_NEUTRON_POROSITY]: [DefaultMnemonic.THERMAL_NEUTRON_POROSITY],
  [BaseParameterTypes.NUMBER_OF_JOINTS]: [DefaultMnemonic.NUMBER_OF_JOINTS],
};
